import { DynamicStandaloneRichtextbox } from '@/components/Richtextbox';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorRichtextbox: LabradorComponent = ({ type, data, meta }) => {
  return (
    <DynamicStandaloneRichtextbox
      markup={data.content}
      data-content-index={meta.contentIndex}
      data-host-path={data.hostPath}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorRichtextbox;
